import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermitSubmitStatusService {

  /* Track if the application package (Variance/Application) is complete for submit */
  private applicationPackageStatus = new BehaviorSubject<boolean>(false);
  currentApplicationPackageStatus = this.applicationPackageStatus.asObservable();

/* Track if the permit annual operating plan (general system operations) is complete for submit */
  private permitAnnualOperatingPlanStatus = new BehaviorSubject<boolean>(false);
  currentPermitAnnualOperatingPlanStatus = this.permitAnnualOperatingPlanStatus.asObservable();

/* Track if the project facility plans (location/sponsors/instruments) is complete for submit */
  private projectFacilityOperatingPlanStatus = new BehaviorSubject<boolean>(false);
  currentProjectFacilityOperatingPlanStatus = this.permitAnnualOperatingPlanStatus.asObservable();

  constructor() { }
  changeApplicationPackageStatus(status: boolean) {
    this.applicationPackageStatus.next(status)
  }

  changePermitAnnualOperatingPlanStatus(status: boolean) {
    this.permitAnnualOperatingPlanStatus.next(status)
  }

  changeProjectFacilityOperatingPlanStatus(status: boolean) {
    this.projectFacilityOperatingPlanStatus.next(status)
  }
}
